import { CgSpinner } from "react-icons/cg";
import { FaCheck, FaRotateRight, FaXmark } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

interface Props {
  isValid: boolean;
  isLoading?: boolean;
  invalidMessage: string;
  handleCheckLocation: () => void;
}
const LocationCheck = ({
  isValid,
  isLoading,
  invalidMessage,
  handleCheckLocation,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="my-1 tracking-body">
      <p className="mb-2 text-sm text-gray-500">
        {t("location_gps_notice")}
      </p>
      {isLoading ? (
        <div className="flex gap-x-2 text-sm text-gray-500">
          <CgSpinner className="mt-0.5 animate-spin" />
          {t("location_checking")}
        </div>
      ) : isValid ? (
        <div className="flex gap-x-2 text-sm text-[#22c55e]">
          <FaCheck className="mt-0.5" />
          {t("location_valid")}
        </div>
      ) : (
        <div className="flex gap-x-1 justify-between">
          <div className="flex gap-x-2 text-sm text-red-500">
            <FaXmark className="mt-0.5" />
            {invalidMessage}
          </div>
          <button
            className="mt-0.5 h-fit text-primary"
            onClick={handleCheckLocation}
          >
            <FaRotateRight />
          </button>
        </div>
      )}
    </div>
  );
};

export default LocationCheck;
